import { render, staticRenderFns } from "./gameExam.vue?vue&type=template&id=26c59c12&scoped=true&"
import script from "./gameExam.vue?vue&type=script&lang=js&"
export * from "./gameExam.vue?vue&type=script&lang=js&"
import style0 from "./gameExam.vue?vue&type=style&index=0&lang=css&"
import style1 from "./gameExam.vue?vue&type=style&index=1&id=26c59c12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c59c12",
  null
  
)

export default component.exports